// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import DefaultFooter from "examples/Footers/DefaultFooter";

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

function Privacidad() {

  return (
    <>
      <DefaultNavbar
        routes={routes}
        sticky
      />
      <MKBox minHeight="30vh"></MKBox>
      <Card
        minHeight="30vh"
        sx={{
          p: 2,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
          backdropFilter: "saturate(200%) blur(30px)",
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <MKBox component="section" >
          <Container>
            <Grid
              container
              item
              flexDirection="column"
              sx={{ textAlign: "justify", my: 6, mx: "auto", px: 0.75 }}
            >
                <MKTypography variant="h4" gutterBottom fontWeight="bold" style={{textAlign: "center"}}>
                    Aviso de Privacidad
                </MKTypography>

                <MKTypography variant="body1" paragraph>
                    <strong>Responsable de la protección de sus datos personales:</strong> ABASTECEDORA DE REFACCIONES Y SERVICIOS ARES (ARES),
                    con domicilio en VILLA DE TEZONTEPEC CENTRO, HIDALGO, CP 43880,
                    es responsable del tratamiento de sus datos personales
                    y se compromete a asegurar la privacidad de la información personal obtenida a través de sus
                    servicios en línea y otros medios permitidos por la ley.
                </MKTypography>

                <MKTypography variant="h5" gutterBottom fontWeight="bold">
                    ¿Para qué fines recabamos y utilizamos sus datos personales?
                </MKTypography>

                <MKTypography variant="body1" paragraph>
                    Sus datos personales serán utilizados para las siguientes finalidades:
                </MKTypography>
                <ul style={{marginLeft: "30px"}}>
                    <li><MKTypography variant="body1">Proveer los servicios y productos requeridos por usted.</MKTypography></li>
                    <li><MKTypography variant="body1">Informar sobre cambios o nuevos productos o servicios.</MKTypography></li>
                    <li><MKTypography variant="body1">Dar cumplimiento a obligaciones contraídas con usted.</MKTypography></li>
                    <li><MKTypography variant="body1">Evaluar la calidad del servicio.</MKTypography></li>
                    <li><MKTypography variant="body1">Realizar estudios internos sobre hábitos de consumo.</MKTypography></li>
                    <li><MKTypography variant="body1">Desarrollar nuevos productos y servicios.</MKTypography></li>
                    <li><MKTypography variant="body1">Informar respecto de promociones y eventos especiales.</MKTypography></li>
                    <li><MKTypography variant="body1">Permitir el acceso a cursos, eventos y actividades laborales.</MKTypography></li>
                </ul>

                <MKTypography variant="h5" gutterBottom fontWeight="bold">
                    Transferencia de datos
                </MKTypography>
                <MKTypography variant="body1" paragraph>
                    Nos comprometemos a no transferir su información personal a terceros sin su consentimiento,
                    salvo las excepciones previstas en el artículo 37 de la Ley Federal de Protección de Datos
                    Personales en Posesión de los Particulares.
                </MKTypography>

                <MKTypography variant="h5" gutterBottom fontWeight="bold">
                    Modificaciones al aviso de privacidad
                </MKTypography>
                <MKTypography variant="body1" paragraph>
                    ABASTECEDORA DE REFACCIONES Y SERVICIOS ARES (ARES) se reserva el derecho de efectuar modificaciones o actualizaciones al presente aviso
                    para adaptarlas a novedades legislativas o requerimientos internos. Estas modificaciones estarán disponibles
                    a través de nuestra página web, anuncios en nuestras sucursales o vía correo electrónico.
                </MKTypography>

                <MKTypography variant="h5" gutterBottom fontWeight="bold">
                    Aceptación de términos
                </MKTypography>
                <MKTypography variant="body1" paragraph>
                    Esta declaración de privacidad está sujeta a los términos y condiciones descritos,
                    lo cual constituye un acuerdo legal entre el usuario y ABASTECEDORA DE REFACCIONES Y SERVICIOS ARES (ARES)
                </MKTypography>

                <MKTypography variant="h5" gutterBottom fontWeight="bold">
                    Contacto
                </MKTypography>
                <MKTypography variant="body1" paragraph>
                    - Domicilio: VILLA DE TEZONTEPEC CENTRO, HIDALGO, CP 43880 <br />
                    - Correo electrónico: ventas@bombasares.com.mx <br />
                    - Teléfonos: 74 3741 0373
                </MKTypography>

                <MKTypography variant="h5" gutterBottom fontWeight="bold">
                    Quejas y denuncias
                </MKTypography>
                <MKTypography variant="body1" paragraph>
                    Si considera que su derecho a la protección de datos ha sido vulnerado, podrá acudir al Instituto Nacional de Transparencia, Acceso a la Información y Protección de Datos Personales (INAI) en: <br />
                    <a href="https://www.inai.org.mx" target="_blank" rel="noopener noreferrer">www.inai.org.mx</a>
                </MKTypography>
            </Grid>
          </Container>
        </MKBox>
      </Card>
      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default Privacidad;
